import convertAddresses from './convertAddress';
import {
	addressWork,
	addressHome,
	addressOther,
} from 'containers/pages/users/data';
import * as TY from 'containers/pages/users/constants';

const convertUser = (user, companies, contactTypes, languages, roles) => {
	let converted = null;
	let _languages = null;
	let mstCust = {};
	let accessOptions = null;

	const hasAddressId = user.addressIds.length > 0;
	const hasLanguage = user.languageIds.length > 0;
	const hasMstId = user.masterCustId !== '';

	const _companies = companies.filter((company) =>
		user.companies.includes(company.Id),
	);
	const _contactTypes = contactTypes.filter((type) =>
		user.contactTypes.includes(type.Id),
	);
	const _roles = roles.filter((role) => user.roles.includes(role.id));

	if (hasAddressId) {
		converted = convertAddresses(user);
	}

	if (hasLanguage) {
		_languages = languages.filter((language) =>
			user.languageIds.includes(language.id),
		);
	}

	if (!hasMstId) {
		mstCust = { RowNumber: '0', Id: '0', Name: TY.ALL_COMPANIES };
		accessOptions = [
			{ RowNumber: '0', Id: '0', Name: TY.ALL_COMPANIES },
			..._companies,
		];
	} else {
		const filtered = companies.filter(
			(company) => company.Id === user.masterCustId,
		);
		mstCust = Object.assign({}, filtered[0]);
		accessOptions = [
			{ RowNumber: '0', Id: '0', Name: TY.ALL_COMPANIES },
			..._companies,
		];
	}

	const userObj = {
		[TY.ID]: user.id,
		[TY.CONTACT_ID]: user.contactId,
		[TY.F_NAME]: user.firstName,
		[TY.L_NAME]: user.lastName,
		[TY.COMPANIES]: _companies,
		[TY.IMAGE]: {
			file: '',
			name: '',
			preview: user.image,
			id: user?.vFileId,
		},
		[TY.EMAIL_WORK]: user.emailWork,
		[TY.EMAIL_PERSONAL]: user.emailPersonal,
		[TY.EMAIL_OTHER]: user.emailOther,
		[TY.CONTACT_TYPES]: _contactTypes,
		[TY.PHONE_WORK]: {
			number: user.phoneWork,
			dialCode: user.phoneWorkDialCode,
			countryCode: user.phoneWorkCountryCode,
			ext: user.phoneWorkExt,
		},
		[TY.PHONE_MOBILE]: {
			number: user.phoneMobile,
			dialCode: user.phoneMobileDialCode,
			countryCode: user.phoneMobileCountryCode,
			ext: user.phoneMobileExt,
		},
		[TY.PHONE_OTHER]: {
			number: user.phoneOther,
			dialCode: user.phoneOtherDialCode,
			countryCode: user.phoneOtherCountryCode,
			ext: user.phoneOtherExt,
		},
		[TY.NOTE]: user.note,
		[TY.ADDRESS_WORK]: hasAddressId ? converted._addressWork : addressWork,
		[TY.ADDRESS_HOME]: hasAddressId ? converted._addressHome : addressHome,
		[TY.ADDRESS_OTHER]: hasAddressId
			? converted._addressOther
			: addressOther,
		[TY.LANGUAGES]: hasLanguage
			? _languages
			: [{ id: '1', code: 'en', name: 'English' }],
		[TY.U_NAME]: user.username,
		[TY.PWD]: '',
		[TY.CONFIRM_PWD]: '',
		[TY.IS_ENABLED]: user.isEnabled,
		[TY.MST_CUST_ID]: mstCust,
		[TY.ACCESS_OPTIONS]: accessOptions,
		[TY.ROLES]: _roles,
		[TY.POST_LOGIN_APP_ID]: user.postLoginAppId,
	};
	return userObj;
};

export default convertUser;
